import { CheckCircle2, Clock, XCircle } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useLingui } from '@lingui/react';
import { msg } from '@lingui/core/macro';
import type { Product } from '../../services/schemas';

type ProductStatus = Product['status'];

interface StatusConfig {
  icon: typeof CheckCircle2;
  className: string;
  label: ReturnType<typeof msg>;
}

const STATUS_MAP: Record<ProductStatus, StatusConfig> = {
  active: {
    icon: CheckCircle2,
    className: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    label: msg`Active`,
  },
  pending: {
    icon: Clock,
    className: 'bg-amber-50 text-amber-700 border-amber-200',
    label: msg`Activation in progress`,
  },
  disabled: {
    icon: XCircle,
    className: 'bg-gray-100 text-gray-500 border-gray-200',
    label: msg`Inactive`,
  },
};

interface ProductStatusBadgeProps {
  status: ProductStatus;
}

export function ProductStatusBadge({ status }: ProductStatusBadgeProps) {
  const { i18n } = useLingui();
  const config = STATUS_MAP[status];
  const Icon = config.icon;

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-semibold border',
        config.className
      )}
    >
      <Icon size={10} />
      {i18n._(config.label)}
    </span>
  );
}
